import router from "@/router";
import ApiService from "@/services/ApiService";
import axiosConnection from "@/services/dbConnection";
import * as Constants from "./constants";
import createPersistedState from "vuex-persistedstate";

function defaultState() {
  return {
    token: null,
    unread_messages: 0,
    token_refreshed: 0,
    accType: null,
    orgId: null,
    settings: null,
  };
}

export default {
  state: defaultState(),
  getters: {},
  mutations: {
    [Constants.LOGGED_IN](state: any, payload: any) {
      state.token = payload.token.token;
      state.token_refreshed = Date.now() / 1000;
      state.user = payload.user;
      if (payload.user.admin_roles.length > 0) {
        state.accType = payload.user.admin_roles[0].slug;
        state.orgId = payload.user.admin_roles[0].admin_organization_id;
      }
      if (
        payload.user.admin_roles_with_settings &&
        payload.user.admin_roles_with_settings.length > 0
      ) {
        state.accType = payload.user.admin_roles_with_settings[0].slug;
        state.orgId =
          payload.user.admin_roles_with_settings[0].admin_organization_id;
        if (payload.user.admin_roles_with_settings[0].settings) {
          state.settings = payload.user.admin_roles_with_settings[0].settings;
        }
      }
      axiosConnection.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${payload.token.token}`;
      localStorage.setItem("token", payload.token.token);
    },
    [Constants.LOGGED_OUT](state: any) {
      localStorage.clear();
      const initial = defaultState();
      Object.keys(initial).forEach((key) => {
        state[key] = initial[key];
      });
      state.user = null;
      state.loading = false;
      state.loadingStarted = null;
    },
    [Constants.LOADING](state: any, bool: boolean) {
      if (bool === true) {
        state.loadingStarted = Math.round(new Date().getTime() / 1000);
      }
      state.loading = bool;
    },
    [Constants.UPDATE_UNREAD_COUNT](state: any, count: number) {
      state.unread_messages = count;
    },
    [Constants.REFRESH_ADMIN_INFO](state: any, payload: any) {
      state.user = payload.user;
    },
    [Constants.SET_REFRESH_TOKEN](state: any, time: number) {
      state.token_refreshed = time;
    },
    [Constants.SET_TOKEN](state: any, token: string) {
      state.token = token;
      axiosConnection.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${token}`;
      localStorage.setItem("token", token);
    },
    initialiseStore(state: any) {
      if (localStorage.getItem("token")) {
        const token = localStorage.getItem("token");
        axiosConnection.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${token}`;
      }
    },
  },
  actions: {
    async attemptLogin({ commit }: any, payload: any) {
      try {
        const result = await ApiService.generalApi.login(payload);
        commit(Constants.LOGGED_IN, result.data);
        router.push("/main/home");
      } catch (e) {
        alert(e);
        if (e.response.status === 401) {
          // this.$notify({
          //   title: "Title",
          //   message: h("i", { style: "color: teal" }, "Wrong credentials")
          // });
        }
      }
    },
    updateUnreadCount({ commit }: any, count: number) {
      commit("UPDATE_UNREAD_COUNT", count);
    },
    logIn({ commit }: any, data: any) {
      commit(Constants.LOGGED_IN, data);
    },
    logout({ commit }: any) {
      commit(Constants.LOGGED_OUT, null, { root: true });
    },
    loading({ commit }: any, bool: boolean) {
      commit(Constants.LOADING, bool);
    },
    refreshAdminInfo({ commit }: any, data: any) {
      commit(Constants.REFRESH_ADMIN_INFO, data);
    },
    setTokenRefreshTime({ commit }: any, time: any) {
      commit(Constants.SET_REFRESH_TOKEN, time);
    },
    setToken({ commit }: any, token: string) {
      commit(Constants.SET_TOKEN, token);
    },
  },
  plugins: [createPersistedState()],
};
